// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.responsive-table {
  height: 75vh;
  overflow: scroll;
}

table {
  width: 100%;
  border-collapse: collapse;
  table-layout: auto;
}

table th,
table td {
  padding: 12px;
  border: 1px solid #ddd;
  white-space: nowrap;
}

table th {
  background-color: #f2f2f2;
  position: sticky;
  top: 0;
  z-index: 1;
}

table tbody tr:nth-child(even) {
  background-color: #f2f2f2;
}

table tbody tr:nth-child(odd) {
  background-color: #fff;
}

table tbody tr:hover {
  background-color: #ddd;
}
`, "",{"version":3,"sources":["webpack://./src/components/BasicTable/index.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":[".responsive-table {\r\n  height: 75vh;\r\n  overflow: scroll;\r\n}\r\n\r\ntable {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  table-layout: auto;\r\n}\r\n\r\ntable th,\r\ntable td {\r\n  padding: 12px;\r\n  border: 1px solid #ddd;\r\n  white-space: nowrap;\r\n}\r\n\r\ntable th {\r\n  background-color: #f2f2f2;\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 1;\r\n}\r\n\r\ntable tbody tr:nth-child(even) {\r\n  background-color: #f2f2f2;\r\n}\r\n\r\ntable tbody tr:nth-child(odd) {\r\n  background-color: #fff;\r\n}\r\n\r\ntable tbody tr:hover {\r\n  background-color: #ddd;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
